import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class Settings extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/setting/get", {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (this.isBlank(this.state.data.record.projectPrice)) this.state.data.record.projectPrice = 0;
        if (this.isBlank(this.state.data.record.certificatePrice)) this.state.data.record.certificatePrice = 0;
        if (this.isBlank(this.state.data.record.almasPrice)) this.state.data.record.almasPrice = 0;
        if (this.isBlank(this.state.data.record.companyResumePrice)) this.state.data.record.companyResumePrice = 0;
        
        if (this.isBlank(this.state.data.record.modlue1ReBuyPerent)) this.state.data.record.modlue1ReBuyPerent = 0;
        if (this.isBlank(this.state.data.record.modlue2ReBuyPerent)) this.state.data.record.modlue2ReBuyPerent = 0;
        if (this.isBlank(this.state.data.record.modlue3ReBuyPerent)) this.state.data.record.modlue3ReBuyPerent = 0;
        if (this.isBlank(this.state.data.record.modlue24ReBuyPerent)) this.state.data.record.modlue24ReBuyPerent = 0;
        
        this.state.data.record.projectPrice = parseInt(this.state.data.record.projectPrice);
        this.state.data.record.certificatePrice = parseInt(this.state.data.record.certificatePrice);
        this.state.data.record.almasPrice = parseInt(this.state.data.record.almasPrice);
        this.state.data.record.companyResumePrice = parseInt(this.state.data.record.companyResumePrice);

        e.preventDefault();
        this.httpPost("api/v1/setting/save", {
            projectPrice: this.state.data.record.projectPrice,
            counselingPercent: this.state.data.record.counselingPercent,
            certificatePrice: this.state.data.record.certificatePrice,
            almasPrice: this.state.data.record.almasPrice,
            companyResumePrice: this.state.data.record.companyResumePrice,

            style: this.state.data.style,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="card-head">
                                            <h5 className="card-title">تنظیمات</h5>
                                        </div>
                                        <ul className="nav nav-tabs mt-n3">
                                            <li className="nav-item">
                                                <a className="nav-link active" data-bs-toggle="tab" href="#pricing"><em className="icon ni ni-info"></em><span>سامانه مشاوران</span></a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" data-bs-toggle="tab" href="#css"><em className="icon ni ni-info"></em><span>استایل سفارشی</span></a>
                                            </li>
                                        </ul>
                                        <div className="tab-content">
                                            <div className="tab-pane active" id="pricing">
                                                <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">هزینه ثبت پروژه مشاوران (ریال)</label>
                                                            <div className="form-control-wrap">
                                                                <input maxLength="13" className="form-control" type="text" defaultValue={this.state.data.record.projectPrice} onChange={e => this.state.data.record.projectPrice = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">هزینه ثبت صفحات تجاری (ریال)</label>
                                                            <div className="form-control-wrap">
                                                                <input maxLength="13" className="form-control" type="text" defaultValue={this.state.data.record.companyResumePrice} onChange={e => this.state.data.record.companyResumePrice = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">هزینه ثبت گواهینامه (ریال)</label>
                                                            <div className="form-control-wrap">
                                                                <input maxLength="13" className="form-control" type="text" defaultValue={this.state.data.record.certificatePrice} onChange={e => this.state.data.record.certificatePrice = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">سهم بابت مشاوره انلاین و تلفنی (درصد)</label>
                                                            <div className="form-control-wrap">
                                                                <input maxLength="13" className="form-control" type="text" defaultValue={this.state.data.record.counselingPercent} onChange={e => this.state.data.record.counselingPercent = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">ارزش ریالی هر الماس</label>
                                                            <div className="form-control-wrap">
                                                                <input maxLength="13" className="form-control" type="text" defaultValue={this.state.data.record.almasPrice} onChange={e => this.state.data.record.almasPrice = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="tab-content">
                                            <div className="tab-pane active" id="pricing">
                                                <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">محتوای استایل سفارشی قالب سایت</label>
                                                            <div className="form-control-wrap">
                                                                <textarea style={{ "height":"400px"}} className="form-control ltr" type="text" defaultValue={this.state.data.style} onChange={e => this.state.data.style = e.target.value}></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}